
import { Vue, Component, Watch } from 'vue-property-decorator';
import BackVoteList from '../components/BackVoteList.vue';
@Component({
  components: {
    BackVoteList,
  },
})
export default class List extends Vue {
  searchText = '请输入作者或作品名称';
  mounted() {}
  // @Watch('id')
  // handleId(newval: any, oldval: any) {
  //   if (newval !== oldval) {
  //     this.id = newval;
  //   }
  // }
}
